import { Grid, GridItem, Text, Image, Link } from "@chakra-ui/react";

export default function Forms() {
  return (
    <Grid
      templateAreas={{ 
        base: `"left" "center" "right"`,  // Mobile: left text, image, right text
        md: `"left center right"` 
      }}
      gridTemplateColumns={{ base: "1fr", md: "1.5fr 1fr 1fr" }}
      h={{ base: "auto", md: "93vh" }}
      py={{ base: "2rem", md: 0 }}
      w="100vw"
      alignItems={"center"}
      bg={"#AABBDC"}
    >
      {/* </Grid><Grid templateColumns="repeat(3, 1fr)" gap={8} w="65%" my="2rem"> */}
      <GridItem
        area={"left"}
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        flexDir={"column"}
        px={{ base: "1rem", md: 0 }}
      >
        <Text
          variant="subHeader"
          align={"center"}
          color="#303030"
          lineHeight={"90%"}
          mb="2rem"
        >
          want to collab?
        </Text>
        <Text
          variant="tinyHeader"
          align={"center"}
          color="#303030"
          lineHeight={"90%"}
          mb="2rem"
        >
          email us at{" "}
          <Link
            variant="pageLinkBig"
            href="https://mail.google.com/mail/u/3/#inbox?compose=CllgCJqWggFKgtgXDPphBmFZQhjQpKxwLwKkHwDqnlsHVJqMtkPtcMmQTRqbgxWZLqhMGSMVxwL"
          >
            snailmail@brown.edu
          </Link>
        </Text>
        <Text variant="subtitle" color="#FFFFFF" w={{ base: "85%", md: "50%" }} mb="2rem">
          Previous collaborations include a lofi study session with VSA, a
          Valentine's Day collab with Birbs@Brown, postcard writing with VISIONS
          Magazine, journaling with LGBTQ Center, scrapbooking with Mosaic+, and
          creative hours with Create@Brown!
          <br />
          <br />
          We've also collaborated with WiSE, CCP, Active Minds, BURP,
          Yarnaholics, and more!
        </Text>
        <Text
          variant="tinyHeader"
          align={"center"}
          color="#303030"
          lineHeight={"90%"}
          mb="2rem"
        >
          or fill out this{" "}
          <Link
            variant="pageLinkBig"
            href="https://docs.google.com/forms/d/e/1FAIpQLSf_CwzYa9_w76D9wCtIrInMly4pQ682MDoXxTPesKQmhvQ1SQ/viewform?usp=dialog"
          >
            collab request form
          </Link>{" "}
          !
        </Text>
      </GridItem>
      <GridItem
        area={"right"}
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        flexDir={"column"}
        px={{ base: "1rem", md: 0 }}
        py={{ base: "2rem", md: 0 }}
      >
        <Text
          variant="tinyHeader"
          align={"center"}
          color="#303030"
          lineHeight={"90%"}
          mb="2rem"
        >
          have feedback or ideas for meetings?
        </Text>
        <Text variant="subtitle" color="#FFFFFF" w={{ base: "85%", md: "50%" }} mb="2rem">
          Let us know any meeting ideas you have, any stationery you want to
          see, any questions, or if you just wanna leave a note by filling out
          this
          <Link
            variant="pageLink2"
            href="https://docs.google.com/forms/d/e/1FAIpQLScW7pVRlyn5ohCzsKe4h59bQ9YFATbt4u4dca0dtVs4NyrQIg/viewform"
          >
            {" "}
            feedback form
          </Link>{" "}
          !
        </Text>
      </GridItem>
      <GridItem
        area={"center"}
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        py={{ base: "2rem", md: 0 }}
      >
        <Image
          objectFit="cover"
          h={{ base: "auto", md: "90%" }}
          w={{ base: "80vw", md: "90%" }}
          margin="10px"
          src="/images/snailmail/eboard_social_1.jpg"
          borderRadius="2%"
        />
      </GridItem>
    </Grid>
  );
}
